// import { useNavigate } from 'react-router-dom';
import configuration from '../../config.js';
import { useLocalData } from '../../hooks/useLocalData';
import AuthenticatedComponent from '../../utilities/AuthenticatedComponent';

export function useApi() {
  const authenticatedComponent = new AuthenticatedComponent();

  const { getLocalData, APP_AUTH_STORAGE_KEY, APP_AUTH_TOKEN_KEY } = useLocalData();

  const fetchJson = async (url: string) => {
    const res = await fetch(url, { headers: authenticatedComponent.generateAuthenticatedHeader() });
    if (!res.ok) throw new Error(`Error: ${res.status}`);
    return res.json();
  };

  async function fetchDataJson(url) {
    const token = getLocalData(APP_AUTH_STORAGE_KEY)[APP_AUTH_TOKEN_KEY];
    const response = await fetch(`${configuration['backend_host']}${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // if (response.status === 401) { handleUnauthorized(); return null; }
    if (!response.ok) throw new Error('Failed to fetch data');
    return response.json();
  }

  async function postData({ url, payload, successCallback, failCallback, method = 'POST' }) {
    try {
      const response = await fetch(url, {
        headers: authenticatedComponent.generateAuthenticatedHeader(),
        body: payload,
        method: method,
      });
      if (!response.ok) {
        console.log('Error response:', response);
        failCallback(response);
        return;
      }
      successCallback(response);
      return response;
    } catch (error) {
      console.error('postData fetch error:', error);
      failCallback(error);
    }
  }

  // async function postDataJson(url, payload, successCallback) {
  //   const token = getLocalData('appAuthToken');

  //   if (!token) {
  //     return null;
  //   }
  //   const response = await fetch(`${url}`, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       Authorization: `Bearer ${token}`,
  //     },
  //     body: JSON.stringify(payload),
  //   });
  //   // if (response.status === 401) { handleUnauthorized(); return null; }
  //   if (!response.ok) throw new Error('Failed to post data');
  //   if (successCallback) {
  //     successCallback();
  //   }
  //   return response.json();
  // }

  return {
    fetchDataJson,
    fetchJson,
    postData,
    // postDataJson,
  };
}
